import React, { useEffect } from 'react';
import { Context } from "../../index";
import { useContext, useState } from "react";
import SpinPage from '../../components/UI/Spin/Spin';
import { useNavigate } from "react-router-dom"
import "./settings.css"
import styles from "./settings.module.css"
import { observer } from 'mobx-react-lite';

import blue from "./imgs/blue.png"
import green from "./imgs/green.png"
import gold from "./imgs/gold.png";
import ukraine from "./imgs/urkaine.png";
import russia from "./imgs/russia.png"
import red from "./imgs/red.png"
import belorus from "./imgs/belorus.png"
import armenia from "./imgs/armenia.png"
import UserService from "../../service/UserService"
import Succses from "../../components/UI/Notification/Succses"
import ErrorComponent from '../../components/UI/Error/ErrorComponent'
import { WordsBan } from "../../Utils/WordsBan"
import Footer from "../../components/Footer/Footer";

import { fillTextPage } from "../../Utils/FillTextPage";
import Dropdown_languages from "../../components/UI/Dropdown_languages";
import Switcher from "../../components/UI/Switcher/Switcher";
import { CopyToClipboard } from "react-copy-to-clipboard/src";
import Bonuses from "../../components/Bonuses/Bonuses";
import { Spin } from 'antd';



const Settings = () => {
    const { store } = useContext(Context);

    const [isAuthChecked, setAuthChecked] = useState(false);
    const [login, setLogin] = useState("");
    const [error, setError] = useState("");
    const [stateSwitch, setStateSwitch] = useState(store.dataLang["settings_name"])
    const [statusErrorChange, setStatusErrorChange] = useState(false);
    const [loading_state, setLoading_state] = useState(false);
    const [statePasswordOld, setStatePasswordOld] = useState(false);

    const [statePasswordNew2, setStatePasswordNew2] = useState(false);
    const [statePasswordNew, setStatePasswordNew] = useState(false);
    


    const [messageSuccses, setMessageSuccses] = useState("")
    const [statusSuccsesChange, setStatusSuccsesChange] = useState(false);
    const [passwordOld, setPasswordOld] = useState("")
    const [passwordNew, setPasswordNew] = useState("")
    const [passwordNew2, setPasswordNew2] = useState("")


    const [currentImage, setCurrentImage] = useState(0);
    const navigate = useNavigate();
    let images;
    let nameImgaes;
    const imagesKordeh = {
        "blue": blue,
        "russia": russia,
        "ukraine": ukraine,
        "green": green,
        "gold": gold,
        "red": red,
        "belorus": belorus,
        "armenia": armenia
    }
    
    if (!store.isLoading && store.user.login) {
        const cur_skin = store.getSkin()
        images = [];
        nameImgaes = [];
        images.push(imagesKordeh[cur_skin]);
        nameImgaes.push(cur_skin);
        const keys = Object.keys(imagesKordeh);
        for (let skin of keys) {
            if (skin !== cur_skin) {
                images.push(imagesKordeh[skin])
                nameImgaes.push(skin);
            }
        }
        // images = [
        //
        //
        // ];

    }

    const nextImage = () => {
        setCurrentImage((prevImage) => (prevImage + 1) % images.length);
    };
    const previousImage = () => {
        setCurrentImage((prevImage) => (prevImage - 1 + images.length) % images.length);
    };

    async function changeSkin() {

        const res = await UserService.change_skin(nameImgaes[currentImage]);

        if (res.status === 200) {
            setStatusSuccsesChange(!statusSuccsesChange)

            setMessageSuccses("success1")
        }
    }


    useEffect(() => {
        fillTextPage("settings", store)
    }, []);
    useEffect(() => {

        if (messageSuccses.length > 0) {
            store.add_message(messageSuccses, Succses)
        }
    }, [statusSuccsesChange]);
    useEffect(() => {

        if (error.length > 0) {
            store.add_message(error, ErrorComponent)
        }
    }, [statusErrorChange]);
    useEffect(() => {
        if (store.isAuth) {
            setAuthChecked(true);
        }

    }, [store.isAuth])
    useEffect(() => {
        if (!store.isLoading) {
            store.setIsLoadingComponent(false)

        }
    }, [store.isLoading]);

    async function handleReset() {


        try {
            setLoading_state(true)
            if (passwordNew === passwordNew2) {

                const answer_from_response = await UserService.change_password({ method: "reset", passwordNew, passwordOld });

                if (answer_from_response.data.err) {
                    store.add_message(answer_from_response.data.err, ErrorComponent)


                } else {
                    store.add_message("Пароль успешно сменен", Succses);
                    setPasswordNew("");
                    setPasswordNew2("")
                    setPasswordOld("")


                }

            }
            else {
                store.add_message("Пароли не совпадают", ErrorComponent);
            }
            setLoading_state(false)

        } catch (e) {
            store.add_message("error1", ErrorComponent)
            setLoading_state(false)




        }

        // Перенаправление на другую страницу


    }
    async function change_login() {
        const answ_ban = WordsBan(login)
        if (answ_ban === "min_length") {
            setStatusErrorChange(!statusErrorChange)

            setError("error21")

        }
        if (answ_ban === "length") {
            setStatusErrorChange(!statusErrorChange)

            setError("error19")
        } else if (answ_ban === "ban_word") {
            setStatusErrorChange(!statusErrorChange)

            setError("error20")

        } else if (answ_ban === "ok") {
            const res = await UserService.change_login(login);
            if (res.data.message === "min_length") {
                setStatusErrorChange(!statusErrorChange)

                setError("error21")

            } else if (res.data.message === "max_length") {
                setStatusErrorChange(!statusErrorChange)

                setError("error19")
            } else if (res.data.message === "ok") {

                window.location.reload()


            } else if (res.data.message === "user_already") {
                setStatusErrorChange(!statusErrorChange)

                setError("error22")
            }
        }


    }

    if (isAuthChecked) {
        if (store.isLoading) {
            return (
                <SpinPage />
            )
        }

        if (!store.isLoading && store.user.login) {
            return (
                <>
                    <div className="settingsCont fadeAnimationMain">
                        <div className={styles.switchBlock}>
                            <Switcher values={[store.dataLang["settings_name"], store.dataLang["money_rooms_text2"]]} onChangeState={setStateSwitch} />
                        </div>
                        {(stateSwitch === store.dataLang["settings_name"] || (!stateSwitch)) && (

                            <>
                                
                                <div className={styles.wrapper} style={{gap:"20px"}}>
                                    <CopyToClipboard
                                        text={store.user.id}
                                        onCopy={() => store.add_message("Успешно скопировано", Succses)}>
                                        <div className={styles.BlcokInf}>
                                            Ваш ID: {store.user.id}
                                        </div>
                                    </CopyToClipboard>
                                    <CopyToClipboard
                                        text={store.user.login}
                                        onCopy={() => store.add_message("Успешно скопировано", Succses)}>
                                        <div className={styles.BlcokInf}>
                                            Текущий логин: {store.user.login}
                                        </div>
                                    </CopyToClipboard>
                                </div>


                                <div className={styles.head}>Изменения данных</div>


                                <div className={styles.wrapper}>





                                    <div className="formContSettings">


                                        <label>Изменить пароль</label>
                                        <div className={styles.passwordContainer}>
                                            <input onChange={e => setPasswordOld(e.target.value)} className="login_input" type={statePasswordOld ? "text" : "password"} placeholder='Введите старый пароль' />
                                            <i class={`fa-solid ${statePasswordOld ? "fa-eye-slash" : "fa-eye"} eye_password`} onClick={() => setStatePasswordOld(prev => !prev)}></i>
                                        </div>
                                        <div className={styles.passwordContainer}>
                                            <input onChange={e => setPasswordNew(e.target.value)} className="login_input" type={statePasswordNew ? "text" : "password"} placeholder='Введите новый пароль' />
                                            <i class={`fa-solid ${statePasswordNew ? "fa-eye-slash" : "fa-eye"} eye_password`} onClick={() => setStatePasswordNew(prev => !prev)}></i>

                                        </div>
                                        <div className={styles.passwordContainer}>

                                            <input onChange={e => setPasswordNew2(e.target.value)} className="login_input" type={statePasswordNew2 ? "text" : "password"} placeholder='Подтвердите пароль' />
                                            <i class={`fa-solid ${statePasswordNew2 ? "fa-eye-slash" : "fa-eye"} eye_password`} onClick={() => setStatePasswordNew2(prev => !prev)}></i>

                                        </div>
                                        <button onClick={async () => {
                                            await handleReset()


                                        }} disabled={loading_state} type="button"
                                            className={`skeleton-button ${styles.buttonAccept}`}>{loading_state ? <Spin style={{ color: "white" }} /> : store.dataLang["confirm_name"]}
                                        </button>





                                    </div>
                                    <div className="formContSettings">
                                        <label>{store.dataLang["change_login_name"]}</label>
                                        <input onChange={e => setLogin(e.target.value)} id="firstname" className="input"
                                            type="text" placeholder={store.dataLang["enter_login_name"]} />
                                        <button onClick={async () => {
                                            await change_login()

                                        }} disabled={loading_state} type="button"
                                            className={`skeleton-button ${styles.buttonAccept}`}>{store.dataLang["confirm_name"]}
                                        </button>
                                    </div>
                                </div>



                                <div className={styles.head}>Изменить скин змейки
                                </div>
                                <div className={styles.wrapper}>


                                    <div className="cont">
                                        <div className="container-setting">

                                            <i onClick={previousImage}
                                                className="fa-solid perec fa-arrow-left previous"></i>

                                            <img src={images[currentImage]} alt="Slider Image" width={200} />
                                            {/*<video src={images[currentImage]} width={500} autoPlay loop muted />*/}

                                            <i onClick={nextImage} className="fa-solid perec fa-arrow-right next"></i>


                                        </div>
                                        <div className="container-accept">
                                            <button onClick={changeSkin}
                                                className="accept">{store.dataLang["confirm_name"]}</button>
                                        </div>

                                    </div>


                                </div>

                                <div className={styles.head}>{store.dataLang["invite_friend_name"]}</div>
                                <div className={styles.wrapper}>
                                    <div className={styles.blockRefUser}>
                                        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>


                                            <div className={styles.headSkin}>Ваша реферальная ссылка</div>
                                            <CopyToClipboard
                                                text={"https://snake.money/friend/" + store.user.id}
                                                onCopy={() => store.add_message("Успешно скопировано", Succses)}>
                                                <div className={styles.linksBlock}>
                                                    <div>{"https://snake.money/friend/" + store.user.id}</div>
                                                </div>
                                            </CopyToClipboard>
                                        </div>
                                        <div style={{ display: "flex", color: "#eee8e8bf" }}>
                                            {/*Пригласите своих друзей присоединиться к нам и наслаждаться играми вместе!*/}
                                            {/*Когда*/}
                                            {/*ваш друг зарегистрируется по вашей ссылке, вы оба получите по 30 бесплатных*/}
                                            {/*спинов. Это отличный способ увеличить свои шансы на выигрыш и поделиться*/}
                                            {/*радостью с близкими.*/}
                                            В разработке
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                        {stateSwitch === store.dataLang["money_rooms_text2"] && (

                            <Bonuses />
                        )}
                    </div>
                    <Footer />
                </>


            )

        }

        if (!store.isLoading && !store.user.login) {
            navigate("")
        }
    }
};

export default observer(Settings);